import { memo } from 'react';

import { Images } from '../../../constants/images';
import { getPathBGByIndex } from '../../../constants/pathBackground';
import { SVGIconType } from '../../../constants/svgIcon';
import { colorForGameSetId } from '../../../constants/Theme/DefaultColors';
import { AlbumSummary } from '../../../models/RecordStore';
import { Album } from '../../../models/SpaceStore/Album';
import { getStringPrefixByLength } from '../../../utils/string';
import { ProgressBar } from '../ProgressBar';
import { SvgIcon } from '../SVGIcon';

import './AlbumNode.css';

export type AlbumNodeProps = {
  album: Album;
  albumSummary?: AlbumSummary | undefined | null;
  onClick: () => void;
  isHideName?: boolean;
};

export const AlbumNode = memo((props: AlbumNodeProps) => {
  const { album, albumSummary, onClick, isHideName } = props;

  const albumInfo =
    album?.i18nGameSetInfo.resources[album?.i18nGameSetInfo.defaultLocale];

  const albumIcon = getPathBGByIndex(
    album?.content?.path[0]?.style.background.set ?? 0,
  );

  const completedGameForChallengeCount =
    albumSummary?.completedGameForChallengeCount ?? 0;
  const gameForChallengeCount = albumSummary?.gameForChallengeCount ?? 1;

  const albumIconTitle = getStringPrefixByLength(
    albumInfo?.name.trim() ?? '',
    1,
  );
  return (
    <div className="album-node">
      <div className="centered-container" onClick={onClick}>
        <div className="album-icon-container">
          <SvgIcon
            name={SVGIconType.BubbleShape}
            color={colorForGameSetId(album.gameSetId)}
            className="bubble-shape"
          />

          <>
            <img
              src={
                album.icons[0]?.publicUrls?.medium ??
                albumIcon ??
                Images.speakingGameBackground
              }
              className="album-icon"
            />
            <div className="album-title-container">
              <p className="album-title">{albumIconTitle}</p>
              {albumSummary?.isCompleted ? (
                <SvgIcon
                  name={'Complete'}
                  width={12}
                  height={12}
                  color="#46CBC0"
                />
              ) : gameForChallengeCount > 0 ? (
                <ProgressBar
                  current={completedGameForChallengeCount}
                  total={gameForChallengeCount}
                  width="2.4rem"
                  height="0.4rem"
                  borderRadius="100px"
                  fillColor="#34A79C"
                />
              ) : null}
            </div>
          </>
        </div>
        {!isHideName && (
          <div className="text-component">
            <p className="album-name">{albumInfo?.name}</p>
          </div>
        )}
      </div>
    </div>
  );
});
